<template>
  <div class="people-section">
    <div class="input_container">
      <p class="mb-3 black">{{ $t("wizard.people") }}</p>
      <div class="flex">
        <div
          v-ripple
          class="plus-minus minus"
          :class="{ disabled: people === 1 }"
          type="button"
          value="-"
          id="moins"
          @click="minus('people')"
        >
          <span class="font-bold">-</span>
        </div>
        <input
          class="input-qty"
          type="text"
          size="2"
          v-model="people"
          @keydown="checkIfNumeric($event)"
        />
        <div
          v-ripple
          class="plus-minus plus"
          :class="{ disabled: people === 8 && getTypeTable === 'vip' }"
          type="button"
          value="+"
          id="plus"
          @click="plus('people')"
        >
          <span class="font-bold">+</span>
        </div>
      </div>
    </div>

    <v-app>
      <div class="vip-checkbox">
        <v-checkbox v-model="vip_checkbox" color="#9a1f35">
          <template v-slot:label>
            {{ $t("wizard.vip_text_1") }}<br />
            {{ $t("wizard.vip_text_2") }}
          </template>
        </v-checkbox>
      </div>
    </v-app>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import axios from "axios";

export default {
  data() {
    return {
      dates: []
    };
  },
  computed: {
    ...mapGetters(['getTypeTable']),
    people: {
      get() {
        return this.$store.getters["getPeople"];
      },
      set(value) {
        this.setPeople(value);
      },
    },
    vip_checkbox: {
      get() {
        return this.$store.getters["getTypeTable"] == "vip";
      },
      set() {
        this.toggleTypeTable();
        if (this.getTypeTable === 'vip' && this.people > 8) {
            this.setPeople(8);
        }
      },
    },
  },
  methods: {
    ...mapMutations(["setPeople", "toggleTypeTable", "setAvaliableTables", "setExceptions"]),
    minus(key) {
      if (this[key] > 0) this[key]--;
      this.getTables();
    },
    plus(key) {
      this[key]++;
      this.getTables();
    },
    checkIfNumeric(e) {
      const k = e.keyCode;
      if (
        !(
          [8, 9, 35, 36, 37, 39, 46].includes(k) ||
          (k >= 48 && k <= 57) ||
          (k >= 96 && k <= 105)
        )
      ) {
        e.preventDefault();
      }
    },
    getTables() {
      axios.get(`/api/tables/free/${this.people}`)
        .then(res => {
          this.setAvaliableTables(res.data)
        }).catch(err => {
          console.log(err);
        })
      axios.get(`/api/exceptions`)
        .then(res => {
          this.setExceptions(res.data)
        }).catch(err => {
          console.log(err);
        })
    },
  },
  created() {
    this.getTables();
  }
};
</script>


<style lang="scss">
.input-container {
  .black {
    color: #1a1a1a;
  }
}

.vip-checkbox {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;

  .v-label .theme--light {
    color: #1a1a1a;
  }
}
</style>
